export default {
  class: 'Clase {number}',
  addClass: 'Agregar clase',
  addClassDescription: 'Comienza a agregar clases a tu recurso',
  teacher: 'Docente',
  student: 'Estudiante',
  editTeacherForm: 'Editar clase para docente',
  editStudentForm: 'Editar clase para estudiante',
  deleteClass: 'Borrar clase',
  deleteClassMessage: '¿Estás seguro que quieres borrar la clase?',
  studentStatement: 'Consigna',
  studentStatementPlaceholder: 'Escribe la consigna de la clase para el estudiante',
  organization: 'Organización',
  organizationPlaceholder: 'Seleccionar la organización',
  time: 'Tiempo (en minutos)',
  classStart: 'Inicio',
  classStartPlaceholder: 'Escribe el inicio de la clase',
  classDevelopment: 'Desarrollo',
  classDevelopmentPlaceholder: 'Escribe el desarrollo de la clase',
  classClosure: 'Cierre',
  classClosurePlaceholder: 'Escribe el cierre de la clase',
  classValuation: 'Valoración',
  classValuationPlaceholder: 'Escribe las sugerencias de evaluación para la clase',
  classLayout: 'Distribución del aula',
  classLayoutPlaceholder: 'Seleccionar la distribución',
  electronicMaterial: 'Material electrónico',
  physicMaterial: 'Material físico',
  electronicMaterialPlaceholder: 'Ej: proyector, ordenador',
  physicMaterialPlaceholder: 'Ej: lápiz, cartón',
  downloadableMaterial: 'Material descargable',
  uploadFile: 'Subir archivo',
  uploading: 'Subiendo...',
  fileSizeError: 'Los archivos no pueden pesar mas de 10mb',
  uploadError: 'Hubo un error al subir el archivo. Intente nuevamente',
  delete: 'Eliminar',
  lectureOrganizations: {
    group: 'Grupal',
    individual: 'Invididual',
    individualGroup: 'Individual/Grupal'
  },
  classPlans: {
    rows: 'Filas',
    groups: 'Grupos',
    circle: 'Círculo',
    halfCircle: 'Medio círculo'
  },
  errors: {
    organizationType: 'La organización es requerida',
    classLayout: 'La distribución es requerida'
  }
}

export const en = {
  class: 'Class {number}',
  addClass: 'Add class',
  addClassDescription: 'Start adding classes to your resource',
  teacher: 'Teacher',
  student: 'Student',
  editTeacherForm: 'Edit class for teacher',
  editStudentForm: 'Edit class for student',
  deleteClass: 'Delete class',
  deleteClassMessage: 'Are you sure you want to delete the class?',
  studentStatement: 'Assignment',
  studentStatementPlaceholder: 'Type the class assignment for the student',
  organization: 'Organization',
  organizationPlaceholder: 'Select the organization',
  time: 'Time (in minutes)',
  classStart: 'Start',
  classStartPlaceholder: 'Type the start of the class',
  classDevelopment: 'Development',
  classDevelopmentPlaceholder: 'Type the development of the class',
  classClosure: 'Closing',
  classClosurePlaceholder: 'Type the closing of the class',
  classValuation: 'Rating',
  classValuationPlaceholder: 'Type the evaluation suggestions for the class',
  classLayout: 'Classroom layout',
  classLayoutPlaceholder: 'Select layout',
  electronicMaterial: 'Electronic material',
  physicMaterial: 'Physical material',
  electronicMaterialPlaceholder: 'E.g.: computer projector',
  physicMaterialPlaceholder: 'E.g.: pencil cardboard',
  downloadableMaterial: 'Downloadable material',
  uploadFile: 'Upload file',
  uploading: 'Uploading...',
  fileSizeError: 'Files can\'t be larger than 10mb',
  uploadError: 'There was an error uploading the file. Please try again',
  delete: 'Delete',
  lectureOrganizations: {
    group: 'Group',
    individual: 'Individual',
    individualGroup: 'Individual/Group'
  },
  classPlans: {
    rows: 'Rows',
    groups: 'Groups',
    circle: 'Circle',
    halfCircle: 'Half circle'
  },
  errors: {
    organizationType: 'Organization is required',
    classLayout: 'Distribution is required'
  }
}

export const ca = {
  class: 'Classe {number}',
  addClass: 'Afegir classe',
  addClassDescription: 'Comença a afegir classes al teu recurs',
  teacher: 'Docent',
  student: 'Estudiant',
  editTeacherForm: 'Editar classe per al docent',
  editStudentForm: 'Editar classe per a l\'estudiant',
  deleteClass: 'Esborrar classe',
  deleteClassMessage: 'Estàs segur que vols esborrar la classe?',
  studentStatement: 'Consigna',
  studentStatementPlaceholder: 'Escriu la consigna de la classe per a l\'estudiant',
  organization: 'Organització',
  organizationPlaceholder: 'Seleccionar l\'organització',
  time: 'Temps (en minuts)',
  classStart: 'Inici',
  classStartPlaceholder: 'Escriu l\'inici de la classe',
  classDevelopment: 'Desenvolupament',
  classDevelopmentPlaceholder: 'Escriu el desenvolupament de la classe',
  classClosure: 'Tancament',
  classClosurePlaceholder: 'Escriu el tancament de la classe',
  classValuation: 'Valoració',
  classValuationPlaceholder: 'Escriu els suggeriments d\'avaluació per a la classe',
  classLayout: 'Distribució de l\'aula',
  classLayoutPlaceholder: 'Seleccionar la distribució',
  electronicMaterial: 'Material electrònic',
  physicMaterial: 'Material físic',
  electronicMaterialPlaceholder: 'Ex: projector ordinador',
  physicMaterialPlaceholder: 'Ex: llapis cartró',
  downloadableMaterial: 'Material descarregable',
  uploadFile: 'Carregar arxiu',
  uploading: 'Carregant...',
  fileSizeError: 'Els arxius no poden pesar més de 10mb',
  uploadError: 'S\'ha produït un error carregant l\'arxiu. Torna-ho a intentar',
  delete: 'Eliminar',
  lectureOrganizations: {
    group: 'Grupal',
    individual: 'Individual',
    individualGroup: 'Individual/Grupal'
  },
  classPlans: {
    rows: 'Files',
    groups: 'Grups',
    circle: 'Cercle',
    halfCircle: 'Mig cercle'
  },
  errors: {
    organizationType: 'L\'organització és requerida',
    classLayout: 'La distribució és requerida'
  }
}
